import { Grid } from '@mui/material';
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import DataGridComponent from '../../components/dataGrid/DataGrid';
import PopUp from '../../components/popup/Popup';
import config from '../../config';
import { getRepairOrderSummary } from '../../redux/actions/dashboardSlice';
import { useAppDispatch, useAppSelector } from '../../store/customHooks';
import { GuestStatusBoard } from '../dashboard/entity';
import FordGuestBoardImageComponent from '../../components/FordGuestBoardImageComponent';
import RefreshIconComponent from '../../components/refreshIconComponent';


const useStyles = makeStyles((theme: any) => ({
  container: {
    marginLeft: "5%",
    backgroundColor: "#3E62A4"
  },
  fordImage: {
    width: "255px",
    // [theme.breakpoints.down("sm")]: {
    //   width: "170px",
    // },
    [theme.breakpoints.down("md")]: {
      width: "140px",
    },
  },
  descriptionBox: {
    height: "121px",
    width: "280px",
    left: "1008px",
    margin: "10px 0px",
    backgroundColor: "#17A6DF",
    borderRadius: "5px",
    // [theme.breakpoints.down("sm")]: {
    //   width: "170px",
    // },
    [theme.breakpoints.down("md")]: {
      width: "140px",
    },
  },
  descriptionHeading: {
    fontSize: "20px",
    fontWeight: 700,
    display: "flex",
    justifyContent: "center",
    color: "white",
    [theme.breakpoints.down("md")]: {
      fontSize: "12px", fontWeight: 500,
    },
  },
  descriptionText: {
    fontSize: "10px",
    display: "flex",
    justifyContent: "center",
    color: "white", marginTop: 10,
    [theme.breakpoints.down("md")]: {
      fontSize: "6px", justifyContent: "center",
    },
  },
}));

export const GuestBoard = (props: any) => {
  const {socket}=props;
  const classes = useStyles();
  const [rows, setRows]:any = useState([]);

  const authData = JSON.parse(localStorage.getItem("AUTH_DATA") || "{}");

  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // let dashBoardData = useAppSelector(
  //   (state: any) => state.dashboard.repairOrderSummary
  // );
  let interval:any="";
  useEffect(() => {
    getList();
    if(socket){
    socket.emit("joinRoom",'RepairOrderSummary:'+authData?.CompanyID)
  }
    return () => {
      setRows([]);
      clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    if(socket){
      
      socket?.on('RepairOrderSummary:'+authData?.CompanyID,(dataSI:any)=>{
        let IDFound = false
        if(dataSI && dataSI?.CompanyID == authData?.CompanyID.toString() && dataSI?.RelationKey==authData?.referenceData?.defaultBranch){
          clearInterval(interval);
          getList()
        
      }
       
      });
  }
    return () => {
      socket.off('RepairOrderSummary');
    };
  }, [socket]);
  const getList = async () => {
    const payload = {
      "CompanyID": authData?.CompanyID.toString()
    };
    const res: any = await dispatch(getRepairOrderSummary(payload));

    if (res?.payload?.success) {
      const data=res?.payload?.data;
      clearInterval(interval);
      setRows(data);
      autoLoadList(data);
      setTotalCount(data)
    }
    if (!(res && res?.payload && res?.payload?.success)) {
      setOpen(true);
    }
  };

  const [totalCount,setTotalCount]=useState([])
 
  const autoLoadList=(dataAuto:any)=>{
    clearInterval(interval);
    let endofpage: any = null;
    let startofpage: any = null;

    if (dataAuto?.length > 0) {
      
      const getRows = (st: number, end: number) => {
        let currentRows = dataAuto.slice(st, end)
        setRows(currentRows)
        start = start + pageSize
        startofpage = start
        end = end + pageSize
        endofpage = end
       
        pageCount = pageCount - 1;
       
      }

      let pageSize: number = 5
      let totalPageCount: number = dataAuto.length / pageSize
      let pageCount: number = parseInt(totalPageCount.toFixed());

      let finalPageCount: number = 0
      if (totalPageCount > pageCount) {
      
        pageCount = pageCount + 1;
        finalPageCount = pageCount
      }
      else
        finalPageCount = pageCount;
      
      let start: number = 0;
      let end: number = pageSize;

      getRows(start, end)

       interval = setInterval(() => {

        if (Math.max(pageCount, 0) === 0) {
         pageCount = finalPageCount
          start = 0;
          end = pageSize;
          startofpage = 0;
          endofpage = 5;

          getRows(startofpage, endofpage)
          return () => {
            clearInterval(interval);
          };
        }
        else {
          getRows(startofpage, endofpage)  
        }

      }, 30000);
    }
  }
  const reload = async (e: any) => {
    e.preventDefault();
    getList();
  };

  const handleClose = () => {
    setOpen(false);
    localStorage.removeItem("AUTH_DATA");
    navigate("/login");
  };

  let onPageChange;
  let onPageSizeChange;
  let onSortChange;

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Header position={'static'} />
        </Grid>

        <RefreshIconComponent onClick={(e: any) => { reload(e) }} />

        <Grid item xs={12}>
          <Grid container >
            <Grid item xs={9} className='gridCss'>
              <DataGridComponent
                getRowId={(row: any,idx:any) => row.DocID}
                rows={rows || []}
                columns={GuestStatusBoard}
                rowCount={totalCount?.length}
                setPage={onPageChange}
                setPageSize={onPageSizeChange}
                onSortChange={onSortChange}
                pageSize={10}
                
              />
              <div style={{textAlign:'right',marginRight:"3%"}}>{rows?.length} / {totalCount?.length} records</div>
            </Grid>
            <Grid item xs={3} >
              <FordGuestBoardImageComponent classes={classes} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Session Expire Popup */}
      <PopUp open={open} handleClose={handleClose} />

    </>
  )
}
